import { FC, PropsWithChildren } from 'react'
import { Resizable } from './Resizable'

export const Sidebar: FC<PropsWithChildren> = ({ children }) => {
    return <Resizable className={'absolute h-screen flex flex-row z-1003 shadow-2xl'}>{children}</Resizable>
}
